/**
 * ------------------------------------------------------------------------
 * HEADER MENU JS
 * ------------------------------------------------------------------------
 */

document.addEventListener("DOMContentLoaded", function() {

    /**
     * Variable
     *
     * @type {{active: boolean, classHamburgerClose: string, classVisible: string, collapse: *, hamburger: *}}
     */
    var configHeaderMenu = {
        active: false,
        classHamburgerClose: 'hamburger_close',
        classVisible: 'header__collapse_show',
        collapse: document.getElementsByClassName('header__collapse')[0],
        hamburger: document.getElementsByClassName('hamburger')[0]
    };

    /**
     * Open menu function
     *
     * @param button
     */
    function menuOpen(button) {
        configHeaderMenu.active = true;
        configHeaderMenu.collapse.classList.toggle(configHeaderMenu.classVisible);
        button.classList.toggle(configHeaderMenu.classHamburgerClose);
    }

    /**
     * Close menu function
     *
     * @param button
     */
    function menuClose(button) {
        button.classList.toggle(configHeaderMenu.classHamburgerClose);
        configHeaderMenu.collapse.classList.toggle(configHeaderMenu.classVisible);
        configHeaderMenu.active = false;
    }

    /**
     * Run on click function
     */
    configHeaderMenu.hamburger.addEventListener('click', function() {
        if(configHeaderMenu.active) {
            menuClose(this);
        } else {
            menuOpen(this);
        }
	});
});